/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchCreateThankYouMessageRequest,
    CheckReviewMessageUpvoteStatusResponse,
    CreateMessageLinkRequest,
    CreateMessageLinkResponse,
    CreateMessageReportRequest,
    CreateVideoMessageRequest,
    CreateVideoMessageResponse,
    LatestUnreviewedOrdersResponse,
    PatchVideoMessageRequest,
    UnupvoteReviewMessageResponse,
    UpvoteReviewMessageResponse,
} from '../models';

export interface MessageApiControllerBatchCreateThankYouMessageRequest {
    storeId: string;
    batchCreateThankYouMessageRequest: BatchCreateThankYouMessageRequest;
}

export interface MessageApiControllerCheckReviewMessageUpvoteStatusRequest {
    messageId: string;
}

export interface MessageApiControllerCreateMessageLinkRequest {
    messageId: string;
    createMessageLinkRequest: CreateMessageLinkRequest;
}

export interface MessageApiControllerCreateMessageReportRequest {
    messageId: string;
    createMessageReportRequest: CreateMessageReportRequest;
}

export interface MessageApiControllerCreateVideoMessageRequest {
    createVideoMessageRequest: CreateVideoMessageRequest;
}

export interface MessageApiControllerDismissMessageReportsRequest {
    messageId: string;
}

export interface MessageApiControllerFeatureVideoMessageRequest {
    messageId: string;
}

export interface MessageApiControllerPatchVideoMessageRequest {
    messageId: string;
    userId: string;
    patchVideoMessageRequest: PatchVideoMessageRequest;
}

export interface MessageApiControllerSendSlackReportRequest {
    messageId: string;
    sellerId: string;
}

export interface MessageApiControllerSwitchMessageToAvailableRequest {
    messageId: string;
}

export interface MessageApiControllerSwitchMessageToUnavailableRequest {
    messageId: string;
}

export interface MessageApiControllerSwitchMessageToUnavailableByAppRequest {
    messageId: string;
    userId: string;
}

export interface MessageApiControllerUnfeatureVideoMessageRequest {
    messageId: string;
}

export interface MessageApiControllerUnupvoteReviewMessageRequest {
    messageId: string;
}

export interface MessageApiControllerUpvoteReviewMessageRequest {
    messageId: string;
}

/**
 * 
 */
export class MessageApi extends runtime.BaseAPI {

    /**
     */
    async messageApiControllerBatchCreateThankYouMessageRaw(requestParameters: MessageApiControllerBatchCreateThankYouMessageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling messageApiControllerBatchCreateThankYouMessage.');
        }

        if (requestParameters.batchCreateThankYouMessageRequest === null || requestParameters.batchCreateThankYouMessageRequest === undefined) {
            throw new runtime.RequiredError('batchCreateThankYouMessageRequest','Required parameter requestParameters.batchCreateThankYouMessageRequest was null or undefined when calling messageApiControllerBatchCreateThankYouMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/messages:batchThankYou`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchCreateThankYouMessageRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerBatchCreateThankYouMessage(requestParameters: MessageApiControllerBatchCreateThankYouMessageRequest): Promise<void> {
        await this.messageApiControllerBatchCreateThankYouMessageRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerCheckReviewMessageUpvoteStatusRaw(requestParameters: MessageApiControllerCheckReviewMessageUpvoteStatusRequest): Promise<runtime.ApiResponse<CheckReviewMessageUpvoteStatusResponse>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerCheckReviewMessageUpvoteStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}:upvoteStatus`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async messageApiControllerCheckReviewMessageUpvoteStatus(requestParameters: MessageApiControllerCheckReviewMessageUpvoteStatusRequest): Promise<CheckReviewMessageUpvoteStatusResponse> {
        const response = await this.messageApiControllerCheckReviewMessageUpvoteStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async messageApiControllerCreateMessageLinkRaw(requestParameters: MessageApiControllerCreateMessageLinkRequest): Promise<runtime.ApiResponse<CreateMessageLinkResponse>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerCreateMessageLink.');
        }

        if (requestParameters.createMessageLinkRequest === null || requestParameters.createMessageLinkRequest === undefined) {
            throw new runtime.RequiredError('createMessageLinkRequest','Required parameter requestParameters.createMessageLinkRequest was null or undefined when calling messageApiControllerCreateMessageLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}/links`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createMessageLinkRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async messageApiControllerCreateMessageLink(requestParameters: MessageApiControllerCreateMessageLinkRequest): Promise<CreateMessageLinkResponse> {
        const response = await this.messageApiControllerCreateMessageLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async messageApiControllerCreateMessageReportRaw(requestParameters: MessageApiControllerCreateMessageReportRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerCreateMessageReport.');
        }

        if (requestParameters.createMessageReportRequest === null || requestParameters.createMessageReportRequest === undefined) {
            throw new runtime.RequiredError('createMessageReportRequest','Required parameter requestParameters.createMessageReportRequest was null or undefined when calling messageApiControllerCreateMessageReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}/reports`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createMessageReportRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerCreateMessageReport(requestParameters: MessageApiControllerCreateMessageReportRequest): Promise<void> {
        await this.messageApiControllerCreateMessageReportRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerCreateVideoMessageRaw(requestParameters: MessageApiControllerCreateVideoMessageRequest): Promise<runtime.ApiResponse<CreateVideoMessageResponse>> {
        if (requestParameters.createVideoMessageRequest === null || requestParameters.createVideoMessageRequest === undefined) {
            throw new runtime.RequiredError('createVideoMessageRequest','Required parameter requestParameters.createVideoMessageRequest was null or undefined when calling messageApiControllerCreateVideoMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createVideoMessageRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async messageApiControllerCreateVideoMessage(requestParameters: MessageApiControllerCreateVideoMessageRequest): Promise<CreateVideoMessageResponse> {
        const response = await this.messageApiControllerCreateVideoMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async messageApiControllerDismissMessageReportsRaw(requestParameters: MessageApiControllerDismissMessageReportsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerDismissMessageReports.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}/reports:dismiss`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerDismissMessageReports(requestParameters: MessageApiControllerDismissMessageReportsRequest): Promise<void> {
        await this.messageApiControllerDismissMessageReportsRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerFeatureVideoMessageRaw(requestParameters: MessageApiControllerFeatureVideoMessageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerFeatureVideoMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}:feature`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerFeatureVideoMessage(requestParameters: MessageApiControllerFeatureVideoMessageRequest): Promise<void> {
        await this.messageApiControllerFeatureVideoMessageRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerLatestUnreviewedOrdersRaw(): Promise<runtime.ApiResponse<LatestUnreviewedOrdersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages:latestUnreviewedOrders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async messageApiControllerLatestUnreviewedOrders(): Promise<LatestUnreviewedOrdersResponse> {
        const response = await this.messageApiControllerLatestUnreviewedOrdersRaw();
        return await response.value();
    }

    /**
     * can update property: videoURL, emoji, for app user
     */
    async messageApiControllerPatchVideoMessageRaw(requestParameters: MessageApiControllerPatchVideoMessageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerPatchVideoMessage.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling messageApiControllerPatchVideoMessage.');
        }

        if (requestParameters.patchVideoMessageRequest === null || requestParameters.patchVideoMessageRequest === undefined) {
            throw new runtime.RequiredError('patchVideoMessageRequest','Required parameter requestParameters.patchVideoMessageRequest was null or undefined when calling messageApiControllerPatchVideoMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/messages/{messageId}`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchVideoMessageRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * can update property: videoURL, emoji, for app user
     */
    async messageApiControllerPatchVideoMessage(requestParameters: MessageApiControllerPatchVideoMessageRequest): Promise<void> {
        await this.messageApiControllerPatchVideoMessageRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerSendSlackReportRaw(requestParameters: MessageApiControllerSendSlackReportRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerSendSlackReport.');
        }

        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling messageApiControllerSendSlackReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/messages/{messageId}:report`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))).replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerSendSlackReport(requestParameters: MessageApiControllerSendSlackReportRequest): Promise<void> {
        await this.messageApiControllerSendSlackReportRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerSwitchMessageToAvailableRaw(requestParameters: MessageApiControllerSwitchMessageToAvailableRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerSwitchMessageToAvailable.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}:set-available`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerSwitchMessageToAvailable(requestParameters: MessageApiControllerSwitchMessageToAvailableRequest): Promise<void> {
        await this.messageApiControllerSwitchMessageToAvailableRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerSwitchMessageToUnavailableRaw(requestParameters: MessageApiControllerSwitchMessageToUnavailableRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerSwitchMessageToUnavailable.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}:set-unavailable`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerSwitchMessageToUnavailable(requestParameters: MessageApiControllerSwitchMessageToUnavailableRequest): Promise<void> {
        await this.messageApiControllerSwitchMessageToUnavailableRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerSwitchMessageToUnavailableByAppRaw(requestParameters: MessageApiControllerSwitchMessageToUnavailableByAppRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerSwitchMessageToUnavailableByApp.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling messageApiControllerSwitchMessageToUnavailableByApp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/messages/{messageId}:set-unavailable`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerSwitchMessageToUnavailableByApp(requestParameters: MessageApiControllerSwitchMessageToUnavailableByAppRequest): Promise<void> {
        await this.messageApiControllerSwitchMessageToUnavailableByAppRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerUnfeatureVideoMessageRaw(requestParameters: MessageApiControllerUnfeatureVideoMessageRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerUnfeatureVideoMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}:unfeature`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async messageApiControllerUnfeatureVideoMessage(requestParameters: MessageApiControllerUnfeatureVideoMessageRequest): Promise<void> {
        await this.messageApiControllerUnfeatureVideoMessageRaw(requestParameters);
    }

    /**
     */
    async messageApiControllerUnupvoteReviewMessageRaw(requestParameters: MessageApiControllerUnupvoteReviewMessageRequest): Promise<runtime.ApiResponse<UnupvoteReviewMessageResponse>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerUnupvoteReviewMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}/upvotes`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async messageApiControllerUnupvoteReviewMessage(requestParameters: MessageApiControllerUnupvoteReviewMessageRequest): Promise<UnupvoteReviewMessageResponse> {
        const response = await this.messageApiControllerUnupvoteReviewMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async messageApiControllerUpvoteReviewMessageRaw(requestParameters: MessageApiControllerUpvoteReviewMessageRequest): Promise<runtime.ApiResponse<UpvoteReviewMessageResponse>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling messageApiControllerUpvoteReviewMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/messages/{messageId}/upvotes`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async messageApiControllerUpvoteReviewMessage(requestParameters: MessageApiControllerUpvoteReviewMessageRequest): Promise<UpvoteReviewMessageResponse> {
        const response = await this.messageApiControllerUpvoteReviewMessageRaw(requestParameters);
        return await response.value();
    }

}
